import { Component, Injectable, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { UrlService } from '../../../shared/services/url.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { BlobStorageService } from '../../../shared/services/blobStorage.service';

import * as moment from 'moment-timezone';
import { TreeNode, ITreeOptions, TreeComponent, TreeModel } from 'angular-tree-component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-storage',
  templateUrl: '../templates/storage.component.html',
  styleUrls: ['../styles/storage.component.css']
})

export class StorageComponent implements OnInit, AfterViewInit {

  @ViewChild('tree') treeComponent: TreeComponent;

  private _title: string;
  private _dashboardUrl: string;
  private _selectedNodePath: string;
  private _folder: string;
  private _selectedContainerName: any;
  private _containerHasFolders: boolean;
  private _containerIsLoading: boolean;
  private _isUploading: boolean;
  private _containersInfo: any;
  private _selectedFiles: any;
  private _treeModel: TreeModel;
  private _nodes: TreeNode[];
  private _options: ITreeOptions;

  constructor(private _urlService: UrlService,
    private _bolbStorageService: BlobStorageService,
    private _alertService: AlertService) {

      this._title = 'Storage';
      this._selectedNodePath = '';
      this._folder = '';
      this._dashboardUrl = this._urlService.GetDashboardRoute();

      this._containerHasFolders = false;
      this._containerIsLoading = false;
      this._isUploading = false;

      moment.tz.setDefault('UTC');

  }

  ngOnInit() {

    this.getContainerNames();

    this._nodes = [];
    this._options = {
      getChildren: this.getNodeChildren.bind(this)
    };

  }

  ngAfterViewInit() {
    this._treeModel = this.treeComponent.treeModel;
  }


  private getNodeChildren(node: TreeNode): Promise<TreeNode[]> {

    const nodePath = this.getNodePath(node);

    return new Promise<TreeNode[]>((resolve, reject) =>
    {
      this.getContainerFolders(this._selectedContainerName.storage, this._selectedContainerName.container, nodePath)
        .subscribe(folders => {
          if (folders.length === 0) {
            node.setField('hasChildren', false);
          }
          resolve(this.parseNodes(folders));
        });
    });
  }

  private getContainerNames() {
    this._bolbStorageService.getContainerNames()
      .subscribe(result => {
        var list = [];
        for (var storageName in result) {
          var containers = result[storageName].containers;
          containers.forEach(function (container) {
            list.push({ storage: storageName, container: container})
          });
        };
        this._containersInfo = list;
      });
  }

  private getFullPath(): string {
    if (this._selectedNodePath != '' && this._folder != '')
      return this._selectedNodePath + '/' + this._folder;
    else if (this._selectedNodePath == '' && this._folder != '')
      return this._folder;
    else
      return this._selectedNodePath;
  }

  private getContainerFolders(storageName: string, containerName: string, path: string) : Observable<any> {
    return this._bolbStorageService.getContainerFolders(storageName, containerName, path);
  }

  private parseNodes(folders): TreeNode[] {

    let nodes: TreeNode[] = folders.map((folder) => {
      return {
        name: folder,
        hasChildren: true,
        isExpanded: false
      };
    });

    return nodes;
  }

  private getNodePath(node: TreeNode): string {

    let nodePath: string = node.data.name;

    while(node.level > 1)
    {

      nodePath = node.parent.data.name + '/' + nodePath;

      node = node.parent;

    }

    return nodePath;
  }


  public handleActivatedNode(event)
  {

    if (event.node)
    {
      let node: TreeNode = event.node;
      this._selectedNodePath = this.getNodePath(node);
    }

  }

  public handleDeactivatedNode(event)
  {
      this._selectedNodePath = '';
      this._treeModel.setFocusedNode(null);
  }

  public handleContainerChanged(event) {

    this._containerIsLoading = true;

    if (event.srcElement.value) {

      this._selectedNodePath = '';
      this._selectedContainerName = JSON.parse(event.srcElement.value);

      this.getContainerFolders(this._selectedContainerName.storage, this._selectedContainerName.container, this._selectedNodePath)
        .subscribe(folders => {

          this._containerHasFolders = folders.length > 0;
          this._nodes = this.parseNodes(folders);
          this._containerIsLoading = false;

        }, error => {

          console.log(error);
          this._containerIsLoading = false;

        });

    }

  }

  public handleFileInput(files: FileList) {
    this._selectedFiles = files;
  }

  public onSubmit() {
    var fullPath = this.getFullPath();
    var itemsProcessed = 0;
    var fileArray = Array.from(this._selectedFiles);
    this._isUploading = true;
    this._bolbStorageService.uploadFile(this._selectedContainerName.storage, this._selectedContainerName.container, fullPath, fileArray as File[]).subscribe(
      data => {
        if (data) {
          var serviceAlert = this._alertService;
          itemsProcessed+= data.length;
          data.forEach(function(uFile){
            console.log('File uploaded: ' + uFile.url);
            serviceAlert.add('success', `File uploaded successfully (${uFile.url}).`);
          });
        }
      },
      undefined,
      () => {
        if(itemsProcessed === fileArray.length)
          this._isUploading = false
      }
    );
  }

  public clearPath() {
    this._selectedNodePath = '';

    this._treeModel.doForAll(function(node: TreeNode) {
      node.setIsActive(false);
      node.setIsSelected(false);
    });

    this._treeModel.setFocusedNode(null);
  }

  public containerHasFolders(): boolean {
    return this._containerHasFolders;
  }

  public containerIsSelected(): boolean {
    return Boolean(this._selectedContainerName);
  }

  public containerIsLoading(): boolean {
    return this._containerIsLoading;
  }

  public parseContainerName(containerName: string) {
    return containerName[0].toUpperCase() + containerName.substr(1).toLowerCase();
  }

  public containerItem(item: any){
    return JSON.stringify(item);
  }

  public isUploadButtonDisabled(): boolean {
    const fileIsSelected = Boolean(this._selectedFiles) && this._selectedFiles.length >= 1;
    return !(this.containerIsSelected() && fileIsSelected && !this._isUploading);
  }

  public isClearButtonDisabled(): boolean {
    return !(Boolean(this._selectedNodePath));
  }

  public saveFolder(folderName) {
    this._folder = folderName;
  }

  public get title() {
    return this._title;
  }

  public get dashboardUrl() {
    return this._dashboardUrl;
  }

  public get nodes() {
    return this._nodes;
  }

  public get options() {
    return this._options;
  }

  public get selectedNodePath() {
    return this._selectedNodePath === '' ? 'No path is selected. Uploading to root folder' : this._selectedNodePath;
  }

  public get containersInfo() {
    return this._containersInfo;
  }

  public get isUploading() {
    return this._isUploading;
  }



}



// WEBPACK FOOTER //
// ./src/app/storage/components/scripts/storage.component.ts